

var $ = require("@alife/alpha-jquery/jquery");
var Base = require("@alife/alpha-base/base");

var _load = [];
var _timer = null;

var Load = Base.extend({    
    attrs: {
        delay: 3000,
        loaded: false
    },
    initialize: function(config) {
        this.initAttrs(config); 
        $(window).bind( 'load', function(){
            if( !this.get('loaded') ){
                this.activeAll();                   
                this.set('loaded', true);
            }
        }.bind(this) );
        _timer = window.setTimeout( function(){
            if(_timer){ window.clearTimeout(_timer); }
            if( !this.get('loaded') ){
                this.activeAll();                   
                this.set('loaded', true);
            }
        }.bind(this), this.get('delay') );
    },
    load: function(opt){
        if(this.get('loaded')){
            this.active(opt);
        }else{
            _load.push(opt);
        }
    },
    activeAll: function(){
        if(this.get('loaded')){ return; }
        _load.forEach(function(item, i){
            this.active(item);
        }.bind(this) );
        _load = [];
    },
    active: function(opt){
        if(!opt){ return; }
        if( $.isFunction(opt) ){ 
            opt.call(null);
            return;
        }
        if( $.isPlainObject(opt) ){
            var scope = opt.scrope || null, cb = opt.callback || function(){};
            cb.call(scope, opt);
            return;
        }
    }
}); 

module.exports = new Load();

